export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4826.8a86f7ed.jpg";